// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal2_component_overlay__IYf_a","modal":"modal2_component_modal__mQhG_","close":"modal2_component_close__AVVzQ","bg":"modal2_component_bg__IxDzM"};